import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { UserService } from 'app/core/user/user.service';
import { listedplace } from 'app/types/listedplace.type';
import { BehaviorSubject, Observable, ReplaySubject, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CatalogsService  {
  private apiURL = this.baseUrl + 'api/catalog';
  private jwtHelper = new JwtHelperService();
  private _authenticated: boolean = false;
  isLoading$ = new BehaviorSubject<boolean>(false);
  private _listedplace: ReplaySubject<listedplace> = new ReplaySubject<listedplace>(1);

  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') private baseUrl: string,
    private _usersService: UserService,
  ) { }

   
  GetCountries(): Observable<any> {
    // this.isLoading$.next(true);
     return this.http.get<any>(this.apiURL + '/getCountries');
  }

  GetTerminalsByAirport(model: any): Observable<any> {
    // gettraveltimeairporttransfer
     return this.http.get<any>(this.apiURL + '/getTerminalsByAirport', {params:model});
   }

   GetAirlinesByAirport(model: any): Observable<any> {
    // gettraveltimeairporttransfer
     return this.http.get<any>(this.apiURL + '/getAirlinesByAirport', {params:model});
   }

  GetAirportTypePlaces(): Observable<any> {
    // this.isLoading$.next(true);
     return this.http.get<any>(this.apiURL + '/getAirportTypePlaces');
  }

  GetPricingPlans(): Observable<any> {
    // this.isLoading$.next(true);
     return this.http.get<any>(this.apiURL + '/getPricingPlans');
  }

}